module.exports = __webpack_public_path__ + "static/media/img1-1.3da9b05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/nutricheck_foliar/P/img1-1.png
// module id = 2317
// module chunks = 3